


















import Vue, { VueConstructor } from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// Supported input types
import InputType from './inputs/types';

// Actual input components
import Inputs from './inputs';

@Component
export default class InputComponent extends Vue {

    @Prop({
        type: String,
        required: true,
        validator(type: InputType): boolean {

            return Object.values(InputType).includes(type);

        },
    })
    private type!: InputType;

    /**
     *  Used to get the correct input component.
     */
    private get inputComponent(): VueConstructor {

        const component = Inputs[this.type];

        if (component) {

            return component;

        }

        throw Error(`Input type ${ this.type } not supported`);

    }

}
